<template>
  <div class="page-card-content" :style="topBackgroundStyle">
    <div class="page-card-type -bottom-up" :style="bottomBackgroundStyle"></div>
    <div class="page-card-container" :class="{ 't-birthday': type === $const.SPECIAL_EVENT_TYPES.BIRTHDAY }">
      <div class="preview-text">
        <h3 class="page--title">{{ title }}</h3>
        <div class="page--owner">
          <div class="page--owner-name" v-html="processedName"></div>
          <div class="page--owner-date" v-html="processedDate"></div>
        </div>
      </div>
    </div>
    <div class="img-circle" :style="AvatarBackgroundStyle" v-if="avatarSrc"></div>
  </div>
</template>

<script>
  export default {
    name: 'SpecialEventCardContent',

    props: {
      type: {
        type: Number,
        default: 1
      },
      name: {
        type: String,
        default: ''
      },
      date: {
        type: String,
        default: ''
      },
      customTitle: {
        type: String,
        default: ''
      },
      avatarSrc: {
        type: String,
        default: ''
      },
      topSrc: {
        type: String,
        default: '/static/img/image-preset-event/01.jpg'
      },
      bottomSrc: {
        type: String,
        defaut: ''
      }
    },

    computed: {
      title () {
        if (this.type === this.$const.SPECIAL_EVENT_TYPES.BIRTHDAY) {
          return 'Happy Birthday'
        } else if (this.type === this.$const.SPECIAL_EVENT_TYPES.ANNIVERSARY) {
          return 'Happy Anniversary'
        } else if (this.type === this.$const.SPECIAL_EVENT_TYPES.OTHER) {
          return this.customTitle || 'Happy Time'
        }
      },

      processedName () {
        return this.name || '&nbsp;'
      },

      processedDate () {
        return this.date || '&nbsp;'
      },

      topBackgroundStyle () {
        return {
          'background-image': `url('${this.topSrc}')`
        }
      },

      bottomBackgroundStyle () {
        return {
          'background-image': `url('${this.bottomSrc}')`
        }
      },

      AvatarBackgroundStyle () {
        return {
          'background-image': `url('${this.avatarSrc}')`
        }
      }
    },

    methods: {
      capture () {
        let display = this.$refs.captureTextDisplay
        let virtual = this.$refs.captureTextVirtual
        let virtualWrapper = this.$refs.captureTextVirtualWrapper

        display.style.display = 'none'
        virtualWrapper.style.display = 'block'

        let currentHeight = 0
        let processing = false
        let currentVirtualInnerHTML = ''

        for (let i = 0; i < this.displayMessage.length; i++) {
          currentVirtualInnerHTML = virtual.innerHTML
          virtual.innerHTML += this.displayMessage[i]
          if (virtual.clientHeight > currentHeight) {
            if (processing) {
              virtual.innerHTML = currentVirtualInnerHTML + '<br/>' + this.displayMessage[i]
            }
            currentHeight = virtual.offsetHeight
            processing = true
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-card-content {
    background-image: url("/static/img/image-preset-event/01.jpg");
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(14, 14, 14, 0.5);
    width: 1200px;
    height: 630px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center -175px;
    background-size: cover;
    position: relative;
    word-wrap: normal;

    .page-card-type {
      position: absolute;
      width: 100%;
      height: 100%;
      bottom: 0;
      left: 0;
      &.-bottom-up {
        background: url('/static/img/image-preset-event/preset-05@2x.jpg') no-repeat;
        background-size: 100%;
        background-position: center bottom;
        // width: 1200px;
        // height: 630px;
      }
    }

    .page-card-container {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;

      // Birthday Type
      &.t-birthday {
        .preview-text {
          color: #fff;
          .page--title {
            color: #fff;
          }
        }
      }
    }

    .preview-text {
      bottom: 3%;
      left: 0;
      right: 0;
      text-align: center;
      position: absolute;
      color: #242424;

      .page--title {
        font-family: 'Mitr', sans-serif;
        color: #242424;
        text-shadow: 1px 2px 2px #00000047;
        font-weight: 500;
        font-size: 3em;
        line-height: 1.2em;
        margin-bottom: 10px;
      }
      .page--owner {
        font-size: 1.8em;
        line-height: 1.5em;
        font-weight: 400;
      }
    }

    .img-circle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 230px;
      height: 230px;
      border-radius: 50%;
      border: 8px solid #fff;
      margin-bottom: 1em;
      box-sizing: border-box;
      background-position: center center;
      background-size: cover
    }
  }
</style>



// WEBPACK FOOTER //
// card-content.vue?5d21568e